import formatMoney from '../formatMoney';

const updateFormControls = ({
  variant,
  qty,
  variantsData,
  optionNames,
  selectedOptions,
  atcButton,
  atcButtonPrice,
  atcButtonPipe,
  quantitySelector
}) => {
  if (!atcButton || !atcButtonPrice || !quantitySelector) return;

  const allOptionsSelected = variantsData.length === 1 || optionNames.every(name => selectedOptions[name]);
  const quantityControls = quantitySelector.querySelectorAll('button, input');

  if (variant && variant.available && allOptionsSelected) {
    quantitySelector.dataset.qtySelectorVariantPrice = variant.price;
    quantityControls.forEach(control => control.removeAttribute('disabled'));
    atcButton.disabled = false;
    atcButtonPrice.textContent = formatMoney(variant.price * qty);
    atcButtonPipe.classList.remove('hidden');
  } else {
    quantityControls.forEach(control => control.setAttribute('disabled', true));
    atcButton.disabled = true;
    atcButtonPrice.textContent = '';
    atcButtonPipe.classList.add('hidden');
  }
};

export default updateFormControls;
